import { BuyerAgreementContextProvider } from 'contexts';
import React from 'react';
import { useParams } from 'react-router-dom';
import { AppointmentBookingInternalContextProvider } from './AppointmentBookingInternalContext';

import AppointmentBookingInternalLayout from './AppointmentBookingInternalLayout';

// Will replace AppointmentBookingInternal.jsx when removing showingsMadeEasyPhase2Feature
const AppointmentBookingInternalPage: React.FC = () => {
  const { listingId } = useParams<{ listingId: string }>();
  return (
    <BuyerAgreementContextProvider>
      <AppointmentBookingInternalContextProvider listingId={listingId}>
        <AppointmentBookingInternalLayout />
      </AppointmentBookingInternalContextProvider>
    </BuyerAgreementContextProvider>
  );
};

export default AppointmentBookingInternalPage;
